import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import style from './Header.module.css';
import RightNav from './RightNav';

interface StyledBurgerProps {
  open: boolean;
}

const StyledBurger = styled.div<StyledBurgerProps>`
  width: 2rem;
  height: 2rem;
  top: 15px;
  right: 20px;
  z-index: 20;
  display: none;

  @media (max-width: 991px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ open }) => (open ? '#ccc' : '#FFF')};
    border-radius: 10px;
    transform-origin: 1px;
   
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }

    &:nth-child(2) {
      transform: ${({ open }) => (open ? 'translateX(100%)' : 'translateX(0)')};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }

    &:nth-child(3) {
      transform: ${({ open }) => (open ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

interface BurgerProps { }

const Burger: React.FC<BurgerProps> = () => {
  const [open, setOpen] = useState<boolean>(false);
  const rightNavObj = useRef<HTMLDivElement>(null);
  const bergerObj = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.body.addEventListener('click', (event) => {
      //rightNavObj.current && !event.composedPath().includes(rightNavObj.current) ||
      if (rightNavObj.current && !event.composedPath().includes(rightNavObj.current) 
        && bergerObj.current && !event.composedPath().includes(bergerObj.current)) {
        setOpen(false);
      }
    })
  }, [])

  return (
    <div className={style.berger}>
      <div ref={bergerObj}>
        <StyledBurger open={open} onClick={() => setOpen(!open)}>
          <div />
          <div />
          <div />
        </StyledBurger>
      </div>
      <div ref={rightNavObj}>
        <RightNav open={open} />
      </div>
    </div>
  );
};

export default Burger;


